(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('OrderBagServiceItemCustom', OrderBagServiceItemCustom);

    OrderBagServiceItemCustom.$inject = ['$resource', 'ENV'];

    function OrderBagServiceItemCustom($resource, ENV) {

        var getOrderBagServiceItemWithEntities = function (OrderBagServiceItemId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/order-bag-service-item-with-entities/' + OrderBagServiceItemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var getActiveOrderBagServiceItems = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/active-order-bag-service-items';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getActiveReserveCountsToBeShown = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/get-active-reserve-count-to-be-shown';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var getReserveStats = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/get-reserve-stats';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET'}
                }
            );
        };

        var getOrderBagServiceItemByCompanyIdFromNow = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/order-bag-service-items-by-company-from-time';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getAllOrderBagServiceItemByCurrentCompany = function () {

            var resourceUrl = 'api/get-all-order-bag-service-items-by-current-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var replaceTime = function (OrderBagServiceItemId, TimeSessionId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/replace-time-order-bag-service-item?orderBagServiceItemId=' + OrderBagServiceItemId + '&timeSessionId=' + TimeSessionId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var checkinOrderBagServieItem = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/checkin-order-bag-service-item';
            return $resource(resourceUrl, {}, {}
            );
        };
        var notCheckinOrderBagServieItem = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/not-checkin-order-bag-service-item';
            return $resource(resourceUrl, {}, {}
            );
        };

        var removeCheckinOrderBagServieItem = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/remove-checkin-order-bag-service-item';
            return $resource(resourceUrl, {}, {}
            );
        };

        var getOrderBagServiceItemByCompanyIdFromDateToDate = function (fromDate, toDate) {
            var resourceUrl = ENV.API_BASE_URL + 'api/get-order-bag-service-items-by-current-company-from-date-to-date?fromDate=' + fromDate + '&toDate=' + toDate;
            ;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var searchOrderBagItemsByQuery = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/search-order-bag-item';
            return $resource(resourceUrl, {}, {
                    'save': {method: 'POST', isArray: true}
                }
            );
        };

        var searchOrderBagItemsByQueryPagination = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/search-order-bag-item-page?sortDirection=desc';
            return $resource(resourceUrl, {}, {
                    'save': {method: 'POST', isArray: true}
                }
            );
        };

        var makeVideoCallLink = function (orderBagItemId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/get-video-link-by-order-bag-item-id?id=' + orderBagItemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };


        var createVideoMeeting = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/client/create-video-meeting';
            return $resource(resourceUrl, {}, {}
            );

        }

        var joinVideoMeeting = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/client/join-video-meeting';
            return $resource(resourceUrl, {}, {}
            );

        }

        var isMeetingRunning = function (orderbagitemId) {
            var resourceUrl = ENV.API_BASE_URL + 'api/client/is-meeting-running/' + orderbagitemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }

        var getMeetingUrl = function (orderbagitemId) {
            var resourceUrl = ENV.API_BASE_URL + 'api/client/get-meeting-url/' + orderbagitemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }


        var createVideoMeetingEvent = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/client/create-video-meeting-event';
            return $resource(resourceUrl, {}, {}
            );

        }

        var joinVideoMeetingEvent = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/client/join-video-meeting-event';
            return $resource(resourceUrl, {}, {}
            );

        }

        var isMeetingRunningEvent = function (serviceitemId, servantId) {
            var resourceUrl = ENV.API_BASE_URL + 'api/client/is-meeting-running-event/' + serviceitemId + '/' + servantId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }

        var makeVideoCallLinkEvent = function (serviceItemId, servantId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/get-video-link-by-service-item-id-and-servant-id?serviceItemId=' + serviceItemId + '&servantId=' + servantId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var editOrderBagServiceItem = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/edit-order-bag-service-item';
            return $resource(resourceUrl, {}, {}
            );
        }


        var searchOrderBagItemsByQueryPage = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/search-order-bag-item-page';
            return $resource(resourceUrl, {}, {
                    'save': {method: 'POST', isArray: true}
                }
            );
        };

        var checkCapacityForItem = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/check-capacity-available-for-order-bag-item';
            return $resource(resourceUrl, {}, {}
            );

        }

        return {
            getReserveStats: getReserveStats,
            getOrderBagServiceItemWithEntities: getOrderBagServiceItemWithEntities,
            getActiveOrderBagServiceItems: getActiveOrderBagServiceItems,
            getActiveReserveCountsToBeShown: getActiveReserveCountsToBeShown,
            getOrderBagServiceItemByCompanyIdFromNow: getOrderBagServiceItemByCompanyIdFromNow,
            getAllOrderBagServiceItemByCurrentCompany: getAllOrderBagServiceItemByCurrentCompany,
            replaceTime: replaceTime,
            checkinOrderBagServieItem: checkinOrderBagServieItem,
            notCheckinOrderBagServieItem: notCheckinOrderBagServieItem,
            removeCheckinOrderBagServieItem: removeCheckinOrderBagServieItem,
            getOrderBagServiceItemByCompanyIdFromDateToDate: getOrderBagServiceItemByCompanyIdFromDateToDate,
            searchOrderBagItemsByQuery: searchOrderBagItemsByQuery,
            searchOrderBagItemsByQueryPagination: searchOrderBagItemsByQueryPagination,
            makeVideoCallLink: makeVideoCallLink,
            createVideoMeeting: createVideoMeeting,
            joinVideoMeeting: joinVideoMeeting,
            isMeetingRunning: isMeetingRunning,
            makeVideoCallLinkEvent: makeVideoCallLinkEvent,
            createVideoMeetingEvent: createVideoMeetingEvent,
            joinVideoMeetingEvent: joinVideoMeetingEvent,
            isMeetingRunningEvent: isMeetingRunningEvent,
            editOrderBagServiceItem: editOrderBagServiceItem,
            getMeetingUrl: getMeetingUrl,
            searchOrderBagItemsByQueryPage: searchOrderBagItemsByQueryPage,
            checkCapacityForItem: checkCapacityForItem
        };
    }
})();
